import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Icon } from '../common/Icon';
import { TaskNotice } from './taskListFilters';

/** The longest the processed task's question is shown before being cut. */
const QUESTION_MAX = 80;

/**
 * The line saying which task was just approved or rejected, shown on the page reached next. It
 * links back to that task, whose page has Reopen, since moving on removed the immediate undo.
 */
export const TaskOutcomeNotice = ({ notice }: { notice?: TaskNotice }) => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (!notice || dismissed) {
    return null;
  }
  const question =
    notice.question.length <= QUESTION_MAX
      ? notice.question
      : `${notice.question.slice(0, QUESTION_MAX)}…`;
  return (
    <div className="alert alert-success" role="status">
      <Icon name={notice.outcome === 'approved' ? 'circle-check' : 'circle-xmark'} />
      <div className="flex-grow-1">
        {t(`task.notice.${notice.outcome}`)} <Link to={`/tasks/${notice.taskId}`}>{question}</Link>
      </div>
      <button
        type="button"
        className="btn-close"
        aria-label={t('task.notice.dismiss')}
        onClick={() => setDismissed(true)}
      />
    </div>
  );
};
